import * as React from 'react';
import { ProgressBar } from '@syncfusion/ej2-progressbar';
import { ComponentBase, applyMixins } from '@syncfusion/ej2-react-base';
/**
 * Represents react ProgressBar Component
 * ```tsx
 * <ProgressBarComponent></ProgressBarComponent>
 * ```
 */
export class ProgressBarComponent extends ProgressBar {
    constructor(props) {
        super(props);
        this.initRenderCalled = false;
        this.checkInjectedModules = true;
        this.directivekeys = { 'progressBarAnnotations': 'progressBarAnnotation', 'rangeColors': 'rangeColor' };
        this.statelessTemplateProps = null;
        this.templateProps = null;
        this.immediateRender = false;
        this.isReactMock = true;
        this.portals = [];
    }
    render() {
        this.isReactMock = false;
        if (((this.element && !this.initRenderCalled) || this.refreshing) && !this.isReactForeceUpdate) {
            super.render();
            this.initRenderCalled = true;
        }
        else {
            return React.createElement('div', this.getDefaultAttributes(), [].concat(this.props.children, this.portals));
        }
    }
}
applyMixins(ProgressBarComponent, [ComponentBase, React.Component]);
